var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCookiesNecessary(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,5 L23,5 C24.1045695,5 25,5.8954305 25,7 L25,15.6481624 C25,18.9916943 23.3289886,22.1140076 20.547002,23.9686654 L17.6641006,25.8905996 C16.6564024,26.5623984 15.3435976,26.5623984 14.3358994,25.8905996 L11.452998,23.9686654 C8.67101135,22.1140076 7,18.9916943 7,15.6481624 L7,7 C7,5.8954305 7.8954305,5 9,5 Z",
    stroke: "#484848",
    strokeWidth: 1.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#797979",
    points: "15 9 17 9 17 17 15 17"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#797979",
    x: 15,
    y: 18.5,
    width: 2,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCookiesNecessary);
export default __webpack_public_path__ + "static/media/ic-cookies-necessary.089754d7b2c812bc25af2fd83ca0c5e5.svg";
export { ForwardRef as ReactComponent };